import React from 'react';

/**
 * Lets a passenger continue without device location by choosing one of the
 * towns where MyTownly is currently live. `blocking` is used before Book's
 * map exists; the same UI is reused by the in-booking town switcher.
 */
export default function TownSelector({
  towns,
  selectedTownId,
  onSelect,
  onUseLocation,
  locating = false,
  blocking = false,
  onClose,
  t,
}) {
  const title = blocking
    ? (t('book.chooseTownTitle') || 'Choose your town')
    : (t('book.switchTownTitle') || 'Switch town');
  const subtitle = blocking
    ? (t('book.chooseTownBody') || 'Select the town where you want to book your auto.')
    : (t('book.switchTownBody') || 'Your pickup must be inside the selected town’s service area.');

  return (
    <section className={`town-selector${blocking ? ' is-blocking' : ''}`} aria-label={title}>
      {!blocking && onClose && (
        <button type="button" className="town-selector-close" onClick={onClose} aria-label={t('common.close') || 'Close'}>×</button>
      )}
      <div className="town-selector-icon" aria-hidden>📍</div>
      <h1>{title}</h1>
      <p>{subtitle}</p>

      <button
        type="button"
        className="town-use-location"
        onClick={onUseLocation}
        disabled={locating}
      >
        <span aria-hidden>⌖</span>
        {locating ? (t('book.locating') || 'Getting location…') : (t('book.useCurrentLocation') || 'Use my location')}
      </button>

      <div className="town-selector-divider"><span>{t('book.orChooseTown') || 'or choose a town'}</span></div>
      <div className="town-selector-list">
        {towns.map((town) => (
          <button
            type="button"
            key={town.id}
            className={`town-option${town.id === selectedTownId ? ' selected' : ''}`}
            onClick={() => onSelect(town.id)}
          >
            <span className="town-option-dot" aria-hidden />
            <span className="town-option-name">{town.name}</span>
            <span className="town-option-radius">{town.radiusKm} km</span>
            {town.id === selectedTownId && <span className="town-option-check" aria-label={t('common.selected') || 'Selected'}>✓</span>}
          </button>
        ))}
      </div>
    </section>
  );
}
